<template>
    <div>
        <a v-on:click="show = !show">
          <span class="icon">
            <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!show"></font-awesome-icon>
            <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="show"></font-awesome-icon>
          </span>
          {{ userName }}
        </a>
        <AbsenceRegistrations v-if="show" :user-id="userId"></AbsenceRegistrations>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

import AbsenceRegistrations from '@/components/AbsenceRegistrations.vue'

export default {
  name: 'AbsenceApproverTable',
  props: {
    userId: String,
    userName: String
  },
  components: {
      AbsenceRegistrations
  },
  data: function() {
    return {
      show: true
    }
  },
}
</script>
<style scoped>
</style>
